import { groupConstants } from '../constants/groupConstants';

const localGroups = JSON.parse(sessionStorage.getItem('group')) ? JSON.parse(sessionStorage.getItem('group')) : [];
const selectedGroupData = JSON.parse(sessionStorage.getItem('selectedGroup')) ? JSON.parse(sessionStorage.getItem('selectedGroup')) : {};

const initialState = { groups: localGroups, selectedGroup: selectedGroupData };

export default function group(state = initialState, action) {
  switch (action.type) {
    case groupConstants.GET_ALL_GROUPS_REQUEST:
      return {
        ...state,
        requesting: true,
      };
    case groupConstants.GET_ALL_GROUPS_SUCCESS:
      return {
        ...state,
        groups: action.group,
        requesting: false,
      };
    case groupConstants.GET_ALL_ALL_GROUPS_FAILURE:
      return {};
    case groupConstants.DELETE_USER_GROUP_REQUEST:
      return {
        ...state,
        requestingDelete: true,
      };
    case groupConstants.DELETE_USER_GROUP_SUCCESS:
      return {
        ...state,
        requestingDelete: false,
        deleted: true,
      };
    case groupConstants.DELETE_USER_GROUP_FAILURE:
      return {
        ...state,
        requestingDelete: false,
        deleted: false,
      };
    case groupConstants.GETGROUPBYID_REQUEST:
      return {
        ...state,
        requestingGroupById: true,
      };
    case groupConstants.GETGROUPBYID_SUCCESS:
      return {
        ...state,
        requestingGroupById: false,
        groupById: action.groupById,
      };
    case groupConstants.GETGROUPBYID_FAILURE:
      return {
        ...state,
        groupById: [],
      };
    case groupConstants.SET_SELECTED_GROUP:
      return {
        ...state,
        selectedGroup: action.group,
      };
    default:
      return state;
  }
}
